import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY;

// Función para crear una petición con tiempo de espera personalizado
const apiWithTimeout = (timeout = 30000) => {
    // Clona la configuración de la instancia actual de axios
    const instance = { ...api };

    // Configura el timeout personalizado
    instance.defaults = {
        ...api.defaults,
        timeout: timeout
    };

    return instance;
};

export const getDuplicateTicketCounts = async (startDate, endDate) => {
    try {
        const start = `${startDate.toISOString().split('T')[0]} 00:00:00`;
        const end = `${endDate.toISOString().split('T')[0]} 23:59:59`;

        // Usar 30 segundos como tiempo de espera (30000ms)
        const result = await apiWithTimeout(30000).get(
            `${urlApi}/administracion/gasoline/getDuplicatedTickets?start=${start}&end=${end}`
        );
        return result.data;

    } catch (error) {
        console.error('Error fetching duplicate ticket counts:', error);
        throw error;
    }
};

export const getDuplicateTicketDetails = async (startDate, endDate) => {
    try {
        const start = `${startDate.toISOString().split('T')[0]} 00:00:00`;
        const end = `${endDate.toISOString().split('T')[0]} 23:59:59`;

        // Usar 30 segundos como tiempo de espera (30000ms)
        const result = await apiWithTimeout(30000).get(
            `${urlApi}/administracion/gasoline/getDuplicatedTicketsDetails?start=${start}&end=${end}`
        );
        return result.data;
    } catch (error) {
        console.error('Error fetching duplicate ticket details:', error);
        throw error;
    }
};


export const updateTicket = async (ticket) => {
    try {
        // In a real application, this would be:
        // const response = await fetch(`${API_BASE_URL}/tickets/${ticket.id}`, {
        //   method: 'PUT',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify(ticket),
        // });
        // return await response.json();

        // Mock implementation
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({ ...ticket, success: true });
            }, 300);
        });
    } catch (error) {
        console.error('Error updating ticket:', error);
        throw error;
    }
};

export const deleteTicket = async (data) => {
    try {
        const result = await apiWithTimeout(30000).post(
            `${urlApi}/administracion/gasoline/deleteDuplicatedTickets`, data);

        return result.data;

    } catch (error) {
        console.error('Error deleting ticket:', error);
        throw error;
    }
};
